export function toDateQueryParam(date) {
    return date ? String(date.getTime() / 1000) : undefined;
}
//# sourceMappingURL=GetEvents.js.map